module.exports = __webpack_public_path__ + "static/media/zscaler.58e5afc6.png";